import gql from 'graphql-tag'

export const findPeopleQuery = gql`
  query findPeople(
    $query: String
    $sort: ListSortInput
    $filters: PersonFilterInput
    $page: Int
    $pageSize: Int
  ) {
    findPeople(
      query: $query
      sort: $sort
      filters: $filters
      page: $page
      pageSize: $pageSize
    ) {
      entries {
        id
        fullName
        email
        cpf
        docNum
        registrationLocation
        isApproved
        isActive
        createdAt
        approvedBy
        lastSeenAt
        profile {
          type
        }
      }
      pageInfo {
        totalCount
        totalPages
        hasNextPage
      }
    }
  }
`

export const findWaitingQuery = gql`
  query findWaiting($registrationLocation: Location!) {
    findPeople(
      filters: {
        isApproved: false
        registrationLocation: $registrationLocation
      }
      sort: { field: "createdAt", order: "DESC" }
      pageSize: 7
    ) {
      entries {
        id
        fullName
        createdAt
      }
    }
  }
`

export const findLastApprovedQuery = gql`
  query findLastApproved($registrationLocation: Location!) {
    findPeople(
      filters: { isApproved: true, registrationLocation: $registrationLocation }
      sort: { field: "approvedAt", order: "DESC" }
      pageSize: 7
    ) {
      entries {
        id
        fullName
        approvedAt
      }
    }
  }
`

export const getPersonQuery = gql`
  query getPerson($id: ID!) {
    getPerson(id: $id) {
      id
      fullName
      firstName
      lastName
      email
      cpf
      docNum
      registrationLocation
      isActive
      isApproved
      accessPeriodStart
      accessPeriodEnd
      approvedAt
      createdAt
      approvedBy
      updatedAt
      lastSeenAt
      profile {
        type
        data
      }
    }
  }
`

export const getPersonHistoryQuery = gql`
  query getPersonHistory($id: ID!, $page: Int, $pageSize: Int) {
    getPersonHistory(id: $id, page: $page, pageSize: $pageSize) {
      entries {
        id
        author
        operation
        createdAt
        changes
      }

      pageInfo {
        totalCount
        totalPages
        hasNextPage
      }
    }
  }
`

export const checkCPFAvailabilityQuery = gql`
  query checkCPFAvailability($cpf: String!) {
    checkCPFAvailability(cpf: $cpf) {
      isAvailable
      isAvailableOnCAV
      isAvailableOnUFFS
      ldapUser
    }
  }
`

export const checkEmailAvailabilityQuery = gql`
  query checkEmailAvailability($email: String!) {
    checkEmailAvailability(email: $email) {
      isAvailable
      isAvailableOnCAV
      isAvailableOnUFFS
      ldapUser
    }
  }
`

export const checkDocNumAvailabilityQuery = gql`
  query checkDocNumAvailability($docNum: String!) {
    checkDocNumAvailability(docNum: $docNum)
  }
`

export const autoRegisterMutation = gql`
  mutation autoRegister($input: AutoRegisterInput!) {
    autoRegister(input: $input) {
      id
      fullName
    }
  }
`

export const createPersonMutation = gql`
  mutation createPerson($input: CreatePersonInput!) {
    createPerson(input: $input) {
      id
      fullName
      firstName
      lastName
      email
      cpf
      docNum
      registrationLocation
      isActive
      isApproved
      accessPeriodStart
      accessPeriodEnd
      createdAt
      lastSeenAt
      profile {
        type
        data
      }
    }
  }
`

export const approveRegistrationMutation = gql`
  mutation approveRegistration($id: ID!) {
    approveRegistration(id: $id) {
      id
      isApproved
      isActive
      accessPeriodStart
      accessPeriodEnd
      approvedBy
      approvedAt
    }
  }
`

export const activatePersonMutation = gql`
  mutation activatePerson($input: ActivatePersonInput!) {
    activatePerson(input: $input) {
      id
      isActive
    }
  }
`

export const activateVisitorFor30DaysMutation = gql`
  mutation activateVisitorFor30Days($id: ID!) {
    activateVisitorFor30Days(id: $id) {
      id
      isActive
    }
  }
`

export const updatePersonMutation = gql`
  mutation updatePerson($input: UpdatePersonInput!) {
    updatePerson(input: $input) {
      id
      fullName
      firstName
      lastName
      email
      cpf
      docNum
      registrationLocation
      isActive
      isApproved
      accessPeriodStart
      accessPeriodEnd
      updatedAt
      approvedBy
      profile {
        type
        data
      }
    }
  }
`

export const forgotPasswordMutation = gql`
  mutation forgotPassword($email: String!) {
    forgotPassword(email: $email)
  }
`

export const resetPasswordMutation = gql`
  mutation resetPassword($input: ResetPasswordInput!) {
    resetPassword(input: $input)
  }
`

export const redefinePasswordMutation = gql`
  mutation redefinePassword($id: ID!) {
    redefinePassword(id: $id)
  }
`

export const personCreatedSubscription = gql`
  subscription {
    personCreated {
      id
      fullName
      createdAt
    }
  }
`

export const personApprovedSubscription = gql`
  subscription {
    personApproved {
      id
      fullName
      approvedAt
    }
  }
`

export const connectedPeopleSubscription = gql`
  subscription {
    connectedPeople
  }
`
